export default "__VITE_ASSET__wu_ZQNw6__"